/*
  Client Code Selector that is suitable for use in forms, not connected to
  Redux etc.
*/
import React from 'react';
import AsyncCreatableSelect from 'react-select3/async-creatable';
import request from 'superagent';
import _ from 'lodash';

const convertOptionsToReactSelectOptions = options => options.map(
  ({text, children}) => ({
    label: text,
    value: text,
    options: children && convertOptionsToReactSelectOptions(children),
  }))

const fetchClientCodeOptions = async inputValue => {
  const res = await request
    .get(`/clientcode/get-codes?query=${inputValue}&page=1`);
  return convertOptionsToReactSelectOptions(res.body.data);
}

// we send "UID--client code", hence we can't let user enter the same length as on PACER
const PACER_MAX_CODE_LENGTH = 32;
const IR_UID_MAX_LENGTH = 6; // work up to million users
const IR_CODE_SPLIT_LENGTH = 2;

const MAX_CODE_LENGTH = PACER_MAX_CODE_LENGTH - IR_UID_MAX_LENGTH - IR_CODE_SPLIT_LENGTH;

const trimClientCode = val => val.substr(0, MAX_CODE_LENGTH);

export default function StandaloneClientCode(props) {

  return  (
    <AsyncCreatableSelect
      defaultOptions
      loadOptions={fetchClientCodeOptions}
      isClearable
      getNewOptionData={ (inputValue, optionLabel) => ({
        value: trimClientCode(inputValue),
        label: <span>
          New code: <strong>{trimClientCode(inputValue)}</strong>
        </span>,
      })}
      { ... props }
    />
  )
}


/*
  You can create Final Form compatible field via
  ```
    <Field
      name="client_code"
      component={FinalFormStandaloneClientCodeAdapter}
    />
  ```
*/
export const FinalFormStandaloneClientCodeAdapter = ({ input: {value, onChange}, ...rest }) => (
  <StandaloneClientCode
    value={{ value: value, label: value }}
    onChange={selectedOption => onChange(_.get(selectedOption, 'value'))}
    {...rest}
  />
);



// WEBPACK FOOTER //
// ./src/clientCode/StandaloneClientCode.jsx